
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import loader from "../../assets/Images/loader.gif";
import Select from "react-select";
// import DateTime from "react-datetime";
import { toast } from "react-toastify";
import { StyledEngineProvider } from "@mui/material/styles";
// import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import Swal from "sweetalert2";
import 'animate.css';

const OptionChangeStatus = [
  { value: "", label: "Select Status" },
  { value: "Hold", label: "Hold" },
  { value: "Resolve", label: "Resolve" },
];

const optionHoldReason = [
  { label: "Hold Reason", value: "0" },
  { label: "Customer Appointment not received", value: "111260000" },
  { label: "Under observation by Customer", value: "111260001" },
  { label: "Massoutage", value: "111260002" },
  { label: "Customer not Contactable", value: "111260003" },
  { label: "Customer Response Awaited", value: "111260004" },
  { label: "Under observation by Spectra", value: "111260005" },
  { label: "Permission Issue", value: "111260006" },
  { label: "Force majeure - COVID", value: "111260007" },
  { label: "Customer House Locked", value: "111260008" },
  { label: "Force majeure - Flood", value: "111260009" },
  { label: "Notice Period Extended on Customer Request", value: "111260010" },
];


const optionCustomerContact = [
  { label: "Select Option", value: "" },
  { label: "Yes", value: "True" },
  { label: "No", value: "False" },
];

const optionMaterialConsumption = [
  { label: "Select Option", value: "" },
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];

const FaultRepairAssignmentTpView = () => {
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // Remove box shadow
      boxShadow: "none",
      backgroundColor: "transparent",
      color: "black",
    }),
    inputFocused: {
      boxShadow: "none",
      fontSize: "14px",
    },
  };
  const [activeForm, setActiveForm] = useState("form1");
  const [loading, setLoading] = useState(false);
  const [showData, setShowData] = useState("");
  const [holdstatus, setholdstatus] = useState("");

  const [etrReasons, setEtrReasons] = useState([]);
  const [etrReasonsOption, setEtrReasonsOption] = useState([]);
  const [changeBin, setChangeBin] = useState([]);
  const [changeBinOption, setChangeBinOption] = useState([]);
  const [changeStatusOption, setChangeStatusOption] = useState(
    OptionChangeStatus[0]
  );
  const dynamicStatusOptions = [...OptionChangeStatus];
  if (holdstatus === "Hold") {
    dynamicStatusOptions.push({ value: "UnHold", label: "UnHold" });
  }
  const [selectedDateTime, setSelectedDateTime] = useState(null);
  const [notesSrNumber, setNotesSrNumber] = useState([]);
  const [activeCode, setActiveCode] = useState("");
  const [optionActiveCode, setOptionActiveCode] = useState([]);
  const [holdReason, setHoldReason] = useState(optionHoldReason[0]);
  const [customerContact, setCustomerContact] = useState(
    optionCustomerContact[0]
  );
  const [materialConsumption, setMaterialConsumption] = useState(
    optionMaterialConsumption[0]
  );
  const [binData, setBinData] = useState({
    remarks: "",
    contactName: "",
    contactNum: "",
  });

  const [isDisabled, setIsDisabled] = useState(false);

  const [slaTime, setSlaTime] = useState("");

  const handleChange = (e) => {
    // console.log(e.target.name, e.target.value);
    setBinData({ ...binData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Build the payload using your state values
    const payload = {
      Action: "saveActionCode",
      ActionCode: activeCode?.value, // assuming activeCode holds the selected action code
      Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f", // update if needed
      ContactNo: binData.contactNum,
      Contacted: customerContact?.value, // depending on your option structure (e.g., "True" or "False")
      CustomerName: binData.contactName,
      EmpId: sessionStorage.getItem("userId"),
      EngId: sessionStorage.getItem("userEmail"),
      HoldReason: holdReason?.value,
      SrNumber: sessionStorage.getItem("ViewSR"),
      UpdatedBy: sessionStorage.getItem("userName"),
    };

    try {
      const response = await fetch(process.env.REACT_APP_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (data) {
        navigate("/dashboard");
      }
      // Handle success or error based on response
      // console.log('API response:', data);
    } catch (error) {
      console.error('Error saving action code:', error);
    }
  };
  const handleUnHold = async () => {
    const payload = {
      Action: "getSRinProgress",
      Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
      SrNumber: sessionStorage.getItem("ViewSR"),
    };

    try {
      const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data) {
        navigate("/dashboard");
      }
      // console.log("UnHold API response:", data);
      // You can also handle any state updates or UI feedback here.
    } catch (error) {
      console.error("Error in UnHold API:", error);
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getSRBySrNumberTP",
          ActionCode: "",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          ContactNo: "",
          Contacted: "",
          CustomerName: "",
          ETR: "",
          ETRReason: "",
          EmailId: "",
          EmpId: "",
          EngId: "",
          HoldReason: "",
          Latitude: "",
          Longitude: "",
          RConeId: "",
          RCthirdId: "",
          RCtwoId: "",
          ReasonOf: "",
          ResolveContacted: "",
          SlotType: sessionStorage.getItem("slotType"),
          Source: "",
          SrNumber: sessionStorage.getItem("ViewSR"),
          TaskType: "Assigned",
          UpdatedBy: "",
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        const result = await response.json();
        // console.log("API Response of getASRBySrNumber:", result);
        if (result && result.Status === "Success") {
          if (result.response && result.response.length > 0) {
            sessionStorage.setItem("subsubTypeId", result.response[0].srSubSubTypeID);
            setShowData(result.response[0]);
            setSlaTime(result.response[0].slaClock);
            const slaString = result.response[0].slaClock; // "2024-11-15 14:56"
            // const slaString = "2025-01-23 21:22:15";
            // Parse the SLA string into a Date object (correct format for JS)
            const slaDate = new Date(slaString.replace(' ', 'T')); // "2024-11-15T14:56"
            setholdstatus(result.response[0].srStatus)
            // Calculate 30 minutes before the slaDate
            const thirtyMinutesBeforeSla = new Date(slaDate.getTime() - 30 * 60 * 1000); // 30 minutes in milliseconds
            // console.log("###", result.response[1].SrTypeTP)
            sessionStorage.setItem("SrTypeTP", result.response[1]?.SrTypeTP);

            // Enable the button 30 minutes before the slaDate
            if (new Date() >= thirtyMinutesBeforeSla) {
              setIsDisabled(false); // Enable the button if we're within the last 30 minutes before slaClock
            } else {
              setIsDisabled(true); // Disable the button if we're not yet within the last 30 minutes
            }
          }
        } else {
          toast.warning(result.ErrorDesc, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
          // console.error("API Error:", result.ErrorDesc);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchEtrReasons = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getETRreasons",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        const result = await response.json();
        // console.log("setEtrReasonsOption",result)
        if (result.Status === "Success") {
          setEtrReasonsOption(result.response); // Set the entire array
          // console.log("setEtrReasonsOption",result.response)
        }
      } catch (error) {
        console.error("Error fetching ETR reasons:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchEtrReasons();
  }, []);

  useEffect(() => {
    const fetchBinmovementSR = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getBinmovementSR",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        const result = await response.json();
        // console.log("setChangeBinOption",result)
        if (result.Status === 1) {
          setChangeBinOption(result.Response);

          // console.log("setChangeBinOption",result.Response)
        }
      } catch (error) {
        console.error("Error fetching ETR reasons:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBinmovementSR();
  }, []);

  useEffect(() => {
    const fetchActioncode = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getActioncodeMst",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          CanId: "",
          RConeId: "",
          RCtwoId: "",
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        const result = await response.json();
        // console.log("Active Code",result)
        if (result.Status === 1) {
          setOptionActiveCode(result.Response);
          // console.log("setChangeBinOption",result.Response)
        }
      } catch (error) {
        console.error("Error fetching ETR reasons:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchActioncode();
  }, []);

  useEffect(() => {
    const fetchNotesBySrNumber = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getNotesBySrNumber",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          SrNumber: showData.srNumber,
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        const result = await response.json();
        // console.log("NotesBySrNumber", result.Notes);
        // setNotesSrNumber(result.Notes);
        if (result.Notes == "cURL Error #:Could not resolve host: crmuat.spectra.co; Unknown error") {
          setNotesSrNumber([]);
        } else {
          setNotesSrNumber(result.Notes);
        }

      } catch (error) {
        console.error("Error fetching ETR reasons:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchNotesBySrNumber();
  }, [showData.srNumber]);

  const handleUpdateETR = async () => {
    // console.log("click");
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Action: "saveEtrDetail",
        ActionCode: "",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        ContactNo: "",
        Contacted: "",
        CustomerName: "",
        ETR: selectedDateTime ? selectedDateTime.format('DD-MM-YYYYTHH:mm:ss') : "",
        ETRReason: etrReasons.value,
        EmailId: "",
        EmpId: "",
        EngId: sessionStorage.getItem("engId"),
        HoldReason: "",
        Latitude: "",
        Longitude: "",
        RConeId: "",
        RCthirdId: "",
        RCtwoId: "",
        ReasonOf: "",
        ResolveContacted: "",
        SlotType: "",
        Source: "",
        SrNumber: sessionStorage.getItem("ViewSR"),
        TaskType: "",
        UpdatedBy: "",
      };
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const responseData = await response.json();
      // console.log(responseData);
      if (responseData.Status == "Success") {
        toast.success("ETR Updated", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } catch (error) {
      console.error("Error updating ETR:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeBin = async () => {
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const binMovementRequestData = {
        Action: "saveBinmovementSR",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        BinId: changeBin.value,
        SrNumber: showData.srNumber,
        "srTypeTP": sessionStorage.getItem("SrTypeTP"),
        username: sessionStorage.getItem("userName"),
        "password": sessionStorage.getItem("password"),
      };

      const notesRequestData = {
        Action: "createSRNotes",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        NoteDes: binData.remarks,
        NoteTitle: "Bin Movement",
        SrNumber: showData.srNumber,
      };

      const [binMovementResponse, notesResponse] = await Promise.all([
        fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(binMovementRequestData),
        }),
        fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(notesRequestData),
        }),
      ]);

      const [binMovementData, notesData] = await Promise.all([
        binMovementResponse.json(),
        notesResponse.json(),
      ]);
      navigate("/dashboard")
      // console.log("Bin Movement Response:", binMovementData);
      // console.log("Notes Response:", notesData);
    } catch (error) {
      console.error("Error handling bin movement:", error);
    } finally {
      setLoading(false);
    }
  };

  const redirectEditMaterial = () => {
    navigate("/editMaterial");
  }


  const handleMRTG = async () => {
    Swal.fire({
      title: "<div style='padding:5px;font-size: 20px;margin:0px;background-color:Black;color:white;'>MRTG Details</div>",
      html: `
      <div style="text-align: justify;">
      <span>Active Status &nbsp; : &nbsp;<span>  </span></span><br/>
      <span>Barring Flag &nbsp; : &nbsp;<span>  </span></span><br/>
      <span>FUP Flag &nbsp; : &nbsp;<span>  </span></span><br/>
      <span>Product Segment &nbsp; : &nbsp;<span>   </span></span><br/>
      <span>Product &nbsp; : &nbsp;<span>      </span></span><br/>
    </div>`,
      showClass: {
        popup: `
          animate__animated
          animate__fadeInUp
          animate__faster`},
      hideClass: {
        popup: `
          animate__animated
          animate__fadeOutDown
          animate__faster
        `
      },
      showConfirmButton: false
    });

    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        "Action": "getMRTGbycanid",
        "Authkey": "AdgT68HnjkehEqlkd4",
        "canID": sessionStorage.getItem("CanId"),
        "dateType": "1"
      }
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const result = await response.json();
      // console.log("getMRTGbycanid",result)

    } catch (error) {
      console.error("Error fetching MRTG:", error);
    } finally {
      setLoading(false);
    }
  }

  const handleChangeETRreason = (selectEtrReason) => {
    setEtrReasons(selectEtrReason);
  };

  const handleChangeChangeBin = (selectBin) => {
    setChangeBin(selectBin);
  };

  const handleChangeChangeStatus = (selectStatus) => {
    setChangeStatusOption(selectStatus);
  };

  const handleChangeActiveCode = (selectCode) => {
    setActiveCode(selectCode);
  };

  const handleChangeHoldReason = (selectHoldReason) => {
    setHoldReason(selectHoldReason);
  };
  const handleChangeCustomerContact = (cusContact) => {
    setCustomerContact(cusContact);
  };

  const handleChangeMaterialConsumption = async (selectedOption) => {
    setMaterialConsumption(selectedOption);
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Action: "saveMaterialConsumptionFlag",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        SrNumber: sessionStorage.getItem("ViewSR"),
        Status: selectedOption.value,
      };
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const result = await response.json();

      // console.log("saveMaterialConsumptionFlag",result)

    } catch (error) {
      console.error("Error fetching ETR reasons:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDateTimeChange = (dateTime) => {
    setSelectedDateTime(dateTime);
    // console.log("setSelectedDateTime :",setSelectedDateTime)
  };

  const navigate = useNavigate();
  const redirectDashboardPage = () => {
    navigate("/dashboard");
  };

  const redirectAddItem = () => {
    navigate("/yourAssignmentAddItem");
  };

  const redirectMaterialCunsumNext = () => {
    navigate("/materialConsumeNext");
  }

  const handleIconClick = (formId) => {
    setActiveForm((prevActiveBox) =>
      prevActiveBox === formId ? null : formId
    );
  };

  return (
    <>
      {/* ************************header*********************** */}
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectDashboardPage}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">SR Details</span>
        </div>
      </div>
      {/* *************************header End*********************** */}

      {loading ? (
        <div className="loader-wrapper">
          <div className="loader">
            <img src={loader} alt="loading...."></img>
          </div>
        </div>
      ) : (
        <div className="container-fluid" style={{ marginTop: "65px" }}>
          <div
            className="contact-toggle"
            onClick={() => handleIconClick("form1")}
          >
            <span className="toggle-text">SR Details</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form1" && (
            <div
              className=" container shadow mb-3 bg-body rounded mt-4"
              id="form1"
            >
              {/* *********Contact Information form******** */}
              <form className="srDetails-form p-3">
                <div>
                  <div className="card-data-row">
                    <span className="card-data-text">SR Number :</span>
                    <span className="card-data-value">{showData.srNumber}</span>
                  </div>
                  <div className="card-data-row">
                    <span className="card-data-text">CAN ID :</span>
                    <span className="card-data-value">
                      {showData.customerID}
                    </span>
                  </div>
                  <div className="card-data-row">
                    <span className="card-data-text">Customer Name :</span>
                    <span className="card-data-value">
                      {showData.customerName}
                    </span>
                  </div>
                  <div className="card-data-row">
                    <span className="card-data-text">Mobile No :</span>
                    <span className="card-data-value customerMobile">
                      {showData.customerMobile}
                    </span>
                  </div>
                  <div className="card-data-row">
                    <span className="card-data-text">Slot Date Time :</span>
                    <span className="card-data-value">{showData.slaClock}</span>
                  </div>
                  <div className="card-data-row">
                    <span className="card-data-text">Address :</span>
                    <span className="card-data-value">
                      {showData.customerAddress}
                    </span>
                  </div>
                  <div className="card-data-row">
                    <span className="card-data-text">Segment :</span>
                    <span className="card-data-value">{showData.segment}</span>
                  </div>
                  <div className="card-data-row">
                    <span className="card-data-text">Type :</span>
                    <span className="card-data-value">{showData.srType}</span>
                  </div>
                  <div className="card-data-row">
                    <span className="card-data-text">Sub Type :</span>
                    <span className="card-data-value">
                      {showData.srSubType}
                    </span>
                  </div>
                  <div className="card-data-row">
                    <span className="card-data-text">POD Name :</span>
                    <span className="card-data-value">{showData.podName}</span>
                  </div>
                  <div className="card-data-row">
                    <span className="card-data-text">Device/port :</span>
                    <span className="card-data-value">
                      {showData.oltname} : {showData.portId}
                    </span>
                  </div>
                  <div className="card-data-row">
                    <span className="card-data-text">Current Status :</span>
                    <span className="card-data-value">{showData.srStatus}</span>
                  </div>
                  <div className="card-data-row">
                    <span className="card-data-text">SLA Time :</span>
                    <span className="card-data-value">{showData.slaClock}</span>
                  </div>
                  <div className="card-data-row">
                    <span className="card-data-text">SLA Status :</span>
                    <span className="card-data-value slaStatus">
                      {showData.slaStatus}
                    </span>
                  </div>
                  <div className="card-data-row">
                    <span className="card-data-text">Customer IP :</span>
                    <span className="card-data-value">
                      {showData.customerIP}
                    </span>
                  </div>
                  <div className="card-data-row">
                    <span className="card-data-text">FONI :</span>
                    <span className="card-data-value">{showData.foni}</span>
                  </div>
                  <div className="card-data-row">
                    <span className="card-data-text">Repeat :</span>
                    <span className="card-data-value">
                      {showData.repeat_sr}
                    </span>
                  </div>
                  <div className="card-data-row">
                    <span className="card-data-text">Massoutage :</span>
                    <span className="card-data-value">
                      {showData.massoutage}
                    </span>
                  </div>

                  <div className="card-data-row">
                    <span className="card-data-text">Created On :</span>
                    <span className="card-data-value">
                      {showData.createdOn}
                    </span>
                  </div>

                </div>
              </form>
            </div>
          )}

          <div
            className="contact-toggle mt-2"
            onClick={() => handleIconClick("form2")}
          >
            <span className="toggle-text">Case Remarks</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form2" && (
            <div
              className=" container shadow mb-3 bg-body rounded mt-4"
              id="form2"
            >
              {/* *********Contact Information form******** */}
              <form className="srDetails-form p-3">
                <div>
                  <div className="card-data-row">
                    <span className="card-data-text">Case Remarks :</span>
                    <span className="card-data-value">
                      {showData.case_remarks}
                    </span>
                  </div>
                </div>
              </form>
            </div>
          )}

          <div
            className="contact-toggle mt-2"
            onClick={() => handleIconClick("form3")}
          >
            <span className="toggle-text">View SR Notes</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form3" && (
            <div
              className=" container shadow mb-3 bg-body rounded mt-4"
              id="form3"
            >
              {/* <div className="p-1">
                {notesSrNumber.map((srnote, index) => (
                  <div key={index} className="border rounded p-1 mt-1">
                    <div>
                      <span className="text-secondary text-weight" style={{}}>
                        Created By :{" "}
                      </span>
                      <span>
                        {srnote.createdby} ({srnote.createdon})
                      </span>
                    </div>
                    <div>
                      <span className=" text-secondary text-weight">
                        Title :{" "}
                      </span>
                      <span>{srnote.title}</span>
                    </div>
                    <div>
                      <span className=" text-secondary text-weight">
                        Description :{" "}
                      </span>
                      <span>{srnote.description}</span>
                    </div>
                  </div>
                ))}
              </div> */}

              <div className="p-1">
                {notesSrNumber.length > 0 ? (
                  notesSrNumber.map((srnote, index) => (
                    <div key={index} className="border rounded p-1 mt-1">
                      <div>
                        <span className="text-secondary text-weight">
                          Created By :{" "}
                        </span>
                        <span>
                          {srnote.createdby} ({srnote.createdon})
                        </span>
                      </div>
                      <div>
                        <span className=" text-secondary text-weight">
                          Title :{" "}
                        </span>
                        <span>{srnote.title}</span>
                      </div>
                      <div>
                        <span className=" text-secondary text-weight">
                          Description :{" "}
                        </span>
                        <span>{srnote.description}</span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="p-1 text-center">No notes found</div>
                )}
              </div>
            </div>
          )}

          <div
            className="contact-toggle mt-2"
            onClick={() => handleIconClick("form4")}
          >
            <span className="toggle-text">ETR</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form4" && (
            <div
              className=" container shadow mb-3 bg-body rounded mt-4"
              id="form4"
            >
              {/* *********Contact Information form******** */}
              <form className="Person-Address-form  p-3">
                <div>
                  <div className="">
                    <label className="select-search-label mt-1">
                      ETR Reason
                    </label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="etrReason"
                      placeholder="Select Reason"
                      styles={style}
                      isSearchable={false}
                      value={etrReasons}
                      onChange={handleChangeETRreason}
                      options={
                        etrReasonsOption &&
                        etrReasonsOption.map((reason) => ({
                          value: reason.Id,
                          label: reason.Name,
                        }))
                      }
                    />
                  </div>

                  {/* {console.log("selectedDateTime",selectedDateTime)} */}
                  {/* <div className="select-container mt-2">
                    <label className="select-search-label">ETR</label>
                    <DateTime
                      className=" datetime-picker "
                      styles={style}
                      value={selectedDateTime}
                      onChange={handleDateTimeChange}
                      dateFormat="DD-MM-YYYY"
                      timeFormat="HH:mm"
                      inputProps={{ style: style.inputFocused }}
                    />
                  </div> */}

                  <div>
                    <label className="select-search-label mt-1">ETR</label>
                    <StyledEngineProvider>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["MobileDateTimePicker"]}>
                          <MobileDateTimePicker
                            value={selectedDateTime}
                            onChange={handleDateTimeChange}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </StyledEngineProvider>
                  </div>

                  <div className=" text-center mt-5 mb-3">
                    <button
                      type="submit"
                      className="btn text-light etr-btn bg-dark mx-auto rounded-pill"
                      onClick={handleUpdateETR}
                      disabled={isDisabled}
                    >
                      Update ETR
                    </button>
                  </div>

                  <div className=" text-center mt-2 mb-3">
                    <button
                      type="submit"
                      className="btn text-light w-25 bg-dark mx-auto rounded-pill"
                    >
                      START
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}

          <div
            className="contact-toggle mt-2"
            onClick={() => handleIconClick("form5")}
          >
            <span className="toggle-text">Bin</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form5" && (
            <div
              className=" container shadow mb-3 bg-body rounded mt-4"
              id="form5"
            >
              {/* *********Bin form******** */}
              <form className="Person-Address-form p-3">
                <div>
                  <div className="">
                    <label className="select-search-label mt-1">
                      Change Bin
                    </label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="etrReason"
                      placeholder="Select Bin"
                      styles={style}
                      isSearchable={false}
                      value={changeBin}
                      onChange={handleChangeChangeBin}
                      options={changeBinOption.map((bin) => ({
                        value: bin.binId,
                        label: bin.teamName,
                      }))}
                    />
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="remarks"
                      name="remarks"
                      value={binData.remarks}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Remarks
                    </label>
                  </div>

                  <div className=" text-center mt-5 mb-2">
                    <button
                      type="submit"
                      className="btn text-light etr-btn bg-dark mx-auto rounded-pill"
                      onClick={handleChangeBin}
                    >
                      CHANGE BIN
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}

          <div
            className="contact-toggle mt-2"
            onClick={() => handleIconClick("form6")}
          >
            <span className="toggle-text">Status</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form6" && (
            <div
              className=" container shadow mb-3 bg-body rounded mt-4"
              id="form6"
            >
              {/* *********Contact Information form******** */}
              <form className="Person-Address-form p-3">
                <div>
                  {/* <div className="">
                    <label className="select-search-label mt-3">
                      Change Status
                    </label>
                    <Select
                      className="basic-single form-control form-control-sm p-1 "
                      classNamePrefix="select"
                      name="etrReason"
                      placeholder="Select Status"
                      styles={style}
                      isSearchable={false}
                      value={changeStatusOption}
                      onChange={handleChangeChangeStatus}
                      options={OptionChangeStatus.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div> */}
                  <div className="">
                    <label className="select-search-label mt-3">Change Status</label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="changeStatus"
                      placeholder="Select Status"
                      styles={style}
                      isSearchable={false}
                      value={changeStatusOption}
                      onChange={handleChangeChangeStatus}
                      options={dynamicStatusOptions.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>
                  {changeStatusOption.value === "UnHold" && (
                    <div className="text-center mt-3">
                      <button
                        type="button"
                        className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                        onClick={handleUnHold}
                      >
                        UnHold
                      </button>
                    </div>
                  )}


                  {changeStatusOption.label === "Resolve" && (
                    <div className="">
                      <label className="select-search-label mt-3">
                        Do you want to View/Add/Replace Material Consumption?
                      </label>
                      <Select
                        className="basic-single form-control form-control-sm p-1 "
                        classNamePrefix="select"
                        name="etrReason"
                        placeholder="Select "
                        styles={style}
                        isSearchable={false}
                        value={materialConsumption}
                        onChange={handleChangeMaterialConsumption}
                        options={optionMaterialConsumption.map((data) => ({
                          value: data.value,
                          label: data.label,
                        }))}
                      />
                    </div>
                  )}

                  {changeStatusOption.label === "Hold" && (
                    <div className="">
                      <label className="select-search-label mt-3">
                        Action Code
                      </label>
                      <Select
                        className="basic-single form-control form-control-sm p-1 "
                        classNamePrefix="select"
                        name="etrReason"
                        placeholder="Select Hold Reason"
                        styles={style}
                        isSearchable={false}
                        value={activeCode}
                        onChange={handleChangeActiveCode}
                        options={optionActiveCode.map((data) => ({
                          value: data.actionCode,
                          label: data.actionCode,
                        }))}
                      />
                    </div>
                  )}

                  {changeStatusOption.label === "Hold" && (
                    <div className="">
                      <label className="select-search-label mt-3">
                        Hold Reason
                      </label>
                      <Select
                        className="basic-single form-control form-control-sm p-1 "
                        classNamePrefix="select"
                        name="etrReason"
                        placeholder="Select Hold Reason"
                        styles={style}
                        isSearchable={false}
                        value={holdReason}
                        onChange={handleChangeHoldReason}
                        options={optionHoldReason.map((data) => ({
                          value: data.value,
                          label: data.label,
                        }))}
                      />
                    </div>
                  )}

                  {changeStatusOption.label === "Hold" && (
                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder=""
                        className=" form-control input-text form-control-sm mt-1"
                        id="contactName"
                        name="contactName"
                        value={binData.contactName}
                        onChange={handleChange}
                      />
                      <label htmlFor="floatingInput" className="mt-2">
                        Contact Name
                      </label>
                    </div>
                  )}

                  {changeStatusOption.label === "Hold" && (
                    <div className="input-box form-floating">
                      <input
                        type="tel"
                        placeholder=""
                        className=" form-control input-text form-control-sm mt-1"
                        id="contactNum"
                        name="contactNum"
                        maxLength="10"
                        pattern="[0-9]{10}"
                        value={binData.contactNum}
                        onChange={handleChange}
                        onKeyDown={(e) => {
                          const allowedKeys = [
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                          ];
                          const isDigit = /\d/.test(e.key);
                          if (isDigit || allowedKeys.includes(e.key)) {
                            return true;
                          } else {
                            e.preventDefault();
                          }
                        }}
                      />
                      <label htmlFor="floatingInput" className=" mt-2">
                        Contact Number
                      </label>
                    </div>
                  )}

                  {changeStatusOption.label === "Hold" && (
                    <div className="">
                      <label className="select-search-label mt-3">
                        Customer Contacted
                      </label>
                      <Select
                        className="basic-single form-control form-control-sm p-1 "
                        classNamePrefix="select"
                        name="etrReason"
                        placeholder="Select "
                        styles={style}
                        isSearchable={false}
                        value={customerContact}
                        onChange={handleChangeCustomerContact}
                        options={optionCustomerContact.map((data) => ({
                          value: data.value,
                          label: data.label,
                        }))}
                      />
                    </div>
                  )}

                  {changeStatusOption.label === "Hold" && (
                    <div className=" text-center mt-5 mb-2">
                      <button
                        type="submit"
                        className="btn text-light etr-btn bg-dark mx-auto rounded-pill"
                        onClick={handleSubmit}
                      >


                        Submit on Hold
                      </button>
                    </div>
                  )}

                  {materialConsumption.label === "No" && (
                    <div className=" text-center mt-5 mb-2">
                      <button
                        type="submit"
                        className="btn text-light etr-btn bg-dark mx-auto rounded-pill"

                        onClick={redirectMaterialCunsumNext}
                      >
                        Next
                      </button>
                    </div>
                  )}
                </div>
              </form>
            </div>
          )}
        </div>
      )}

      <div className="" style={{ marginTop: "100px" }}></div>

      <div className="container-fluid position-fixed  bottom-0 p-0">
        {materialConsumption.label === "Yes" && (
          <div className=" yourAssign-add-icon " onClick={redirectAddItem}>
            <span className="bg-dark p-2 rounded-circle faPlus-icon">
              <i className="fa-solid fa-plus text-light m-1"></i>
            </span>
          </div>
        )}

        <div className=" bottom-container-style">
          <ul className="text-light">
            <li>
              <i className="fa-solid fa-pen"></i>
              <br />
              <span>NOC</span>
            </li>
            <li onClick={redirectEditMaterial}>
              <i className="fa-solid fa-pen"></i>
              <br />
              <span>Edit Material</span>
            </li>
            <li onClick={handleMRTG}>
              <i className="fa-solid fa-pen"></i>
              <br />
              <span>MRTG</span>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default FaultRepairAssignmentTpView;

